import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandJobcardAddPage } from './cabsand-jobcard-add';

@NgModule({
  declarations: [
    CabsandJobcardAddPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandJobcardAddPage),
  ],
})
export class CabsandJobcardAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-jobcard-add/cabsand-jobcard-add.module.ts